import {
  Serializer, QuestionPanelDynamicModel,
} from 'survey-core';

const PERSONAL_GUARANTOR_QUESTION_TYPE = 'personal-guarantors';

// The Third party question is simply a wrapper/copy of the Dynamic Panel question type.
Serializer.addClass(
  PERSONAL_GUARANTOR_QUESTION_TYPE,
  [],
  () => new QuestionPanelDynamicModel(''),
  'paneldynamic',
);

export const registerPersonalGuarantorsQuestion = () => {
  // Serializer.addClass() is all we need for now and it is called at module level
};
